
// import React,{ useState, useEffect } from "react";
import React  ,{ useState, useEffect } from'react'

const Timer = (props) => {

  const { initialMinute = 0, initialSeconds = 0, apicallSendCode, backgroundColor } = props;
  const [minutes, setMinutes] = useState(initialMinute);
  const [seconds, setSeconds] = useState(initialSeconds);

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(myInterval);
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });


  const handleRefresh = () => {
    props.handleClickAgain()
    setMinutes(2)
    setSeconds(0)
    apicallSendCode("refresh")
  }

  return (
    <>
      {minutes === 0 && seconds === 0 && (
        <div
          style={{
            backgroundColor: backgroundColor ? backgroundColor : "#FFF",
            width: 130,
            height: 41,
            borderRadius: 5,
            cursor: 'pointer',
            margin: "0 auto",
          }}
          className="flex justify-center items-center"
        >
          <div className="flex justify-center text-xs" onClick={() => handleRefresh()} >
            <div className='text-primaryColor' style={{ margin: 0, marginLeft: 2, marginTop: 15  , textAlign:'center'}}>
              {/* <Refresh style={{ marginLeft: 4 }} /> */}
              <img src={"/assets/icons/Refresh.svg"} alt="" onClick={() => handleRefresh()} style={{ cursor: 'pointer' }} />
              {"ارسال مجدد کد"}
            </div>
          </div>
        </div>
      )}
      {minutes !== 0 || seconds !== 0 ? (
        <div
          style={{
            backgroundColor: backgroundColor ? backgroundColor : "#FFF",
            width: '100%',
            height: 41,
            borderRadius: 5,
            margin: "15px auto 5px auto",
          }}
          className="flex justify-center items-center"
          onClick={(event) => event.stopPropagation()}
        >
          <div className="flex items-center" style={{ color: "#101010", width: '100%', textAlign: 'center', whiteSpace: 'noWrap' }}>
            {/* <MdTimer className="mb-1" style={{ fontSize: "16" }} /> */}
            <span>
            <span className="mr-1" style={{ margin: 0 , marginLeft:5 }}>
              {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
            </span>
              تا ارسال مجدد کد
            </span>
          </div>
        </div>
      ) : (null)}
    </>
  );
};

export default Timer;
